export default "#if !EXTRA\n\n#define EXTRA\n\nconst doSomethingExtra = (str: string) : string => String.sub(0n, 2n, str);\n\n#endif\n\n";